import React, { Component } from 'react';

import styles from './TvBannerCarousel.module.scss';

const ADVANCE_INTERVAL_MS = 6000;

/**
 * Auto-scrolling promo banner strip for the TV (FireTV/Roku/Samsung/Sky) lobby.
 * Display-only: aria-hidden and no focusable children, so the TV remote's
 * spatial navigation skips straight over it.
 */
class TvBannerCarousel extends Component {
    state = { index: 0 };

    componentDidMount() {
        this.startTimer();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.banners?.length !== this.props.banners?.length) {
            this.setState({ index: 0 });
            this.startTimer();
        }
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    startTimer() {
        clearInterval(this.timer);
        if ((this.props.banners?.length || 0) > 1) {
            this.timer = setInterval(() => {
                if (document.hidden) return;
                this.setState((prev) => ({ index: (prev.index + 1) % this.props.banners.length }));
            }, ADVANCE_INTERVAL_MS);
        }
    }

    render() {
        const banners = this.props.banners || [];
        if (banners.length === 0) return null;

        // Rendered as an <li> so it can live inside the lobby .games flexbox:
        // flex-basis 100% forces it onto its own row with the grid's own gap.
        return (
            <li className={styles.bannerRow} aria-hidden="true" data-banner="true">
                <div className={styles.carousel}>
                    <div className={styles.track} style={{ transform: `translateX(-${this.state.index * 100}%)` }}>
                        {banners.map((url, i) => (
                            <img className={styles.banner} src={url} alt="" draggable={false} key={`${url}-${i}`} />
                        ))}
                    </div>
                </div>
            </li>
        );
    }
}

export default TvBannerCarousel;
